// extracted by mini-css-extract-plugin
export var inner = "index-module--inner--21e0b";
export var nav_list_container = "index-module--nav_list_container--595a5";
export var nav_title_cards_container = "index-module--nav_title_cards_container--9571c";
export var nav_title_cards_container_without_border = "index-module--nav_title_cards_container_without_border--f7067";
export var stretch = "index-module--stretch--24129";
export var wrapper = "index-module--wrapper--36c96";